import { PerksDrawbackProps } from "./PerksDrawback";

export const basicJobLabel: string = "Basic Job";
export const premiumJobLabel: string = "Premium Job";
export const basicJobPerksDrawbacks: PerksDrawbackProps = {
  list: [
    {
      type: "perk",
      value: "Low number of direct applies"
    },
    {
      type: "perk",
      value: "Low number of database matches"
    },
    {
      type: "drawback",
      value: "Increased job reach"
    },
    {
      type: "drawback",
      value: "Get noticed by an urgent hiring tag"
    }
  ]
};
export const premiumJobPerksDrawbacks: PerksDrawbackProps = {
  list: [
    {
      type: "perk",
      value: "High number of direct applies"
    },
    {
      type: "perk",
      value: "High number of database matches"
    },
    {
      type: "perk",
      value: "Increased job reach"
    },
    {
      type: "perk",
      value: "Get noticed by an urgent hiring tag"
    }
  ]
};
